module.exports = __webpack_public_path__ + "media/images/products/products/modal/2-b71f77f6c85786a3a3af236a9eae8598.jpg";